import React, { useContext } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import { RenderDates } from "../RenderDates/RenderDates";
import { ActionsMenu } from "../../../../components/ActionsMenu/ActionsMenu";
import PencilEditIcon from "../../../../components/VectorIcons/PencilEditIcon";
import DeleteIcons from "../../../ProjectSheet/ListFiles/BlockList/DeleteIcons/DeleteIcons";
import { PlanningGridContext, SelectionContext } from "../PlanningGrid";
import { CHECKBOX_SX } from "./MaterialSection.utils";

export const MaterialVersionRow = ({
  versao,
  attachments,
  canDeleteWholeVersion,
  handleEdit,
  handleDeleteVersion,
  toggleMany,
}) => {
  const { grid, headerGroups, isSelectionMode: selectionMode } =
    useContext(PlanningGridContext);
  const { selectedFileIds } = useContext(SelectionContext);

  const allVersionSelected =
    attachments.length > 0 &&
    attachments.every((a) => selectedFileIds.has(a.id));

  const someVersionSelected =
    attachments.some((a) => selectedFileIds.has(a.id)) && !allVersionSelected;

  return (
    <Box
      display="grid"
      gridTemplateColumns={grid}
      sx={{
        borderBottom: "1px solid #e0e2ff",
        minHeight: "52px",
      }}
    >
      {selectionMode && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Checkbox
            checked={allVersionSelected}
            indeterminate={someVersionSelected}
            onChange={() => toggleMany(attachments)}
            disabled={attachments.length === 0}
            size="small"
            sx={CHECKBOX_SX}
          />
        </Box>
      )}

      <Box
        display="flex"
        alignItems="center"
        pl={selectionMode ? "0" : "16px"}
      >
        <Typography
          fontWeight="bold"
          sx={{
            fontFamily: "inherit",
            fontSize: "10px",
            textTransform: "uppercase",
            color: "#5c6db8",
          }}
        >
          {versao.version}ª Versão
        </Typography>
      </Box>

      <RenderDates
        columns={headerGroups}
        planning={versao.planning}
        realized={versao.realized}
      />

      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        flex="1"
        sx={{ pr: "8px" }}
      >
        <ActionsMenu
          menuOptions={[
            {
              action: () => handleEdit(versao, "material"),
              label: "Editar",
              icon: <PencilEditIcon />,
            },
            {
              action: () => handleDeleteVersion(versao),
              label: "Remover",
              disabled: !canDeleteWholeVersion,
              icon: (
                <DeleteIcons
                  returnColor={() => (canDeleteWholeVersion ? "#000" : "#CCC")}
                />
              ),
            },
          ]}
          disabled={selectionMode}
        />
      </Box>
    </Box>
  );
};
